"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _closebtn = _interopRequireDefault(require("../assets/closebtn.png"));
var _closebtnDark = _interopRequireDefault(require("../assets/closebtnDark.png"));
var _NoFormInputs = _interopRequireDefault(require("../components/NoFormInputs"));
var Banner = function Banner(props) {
  var description = props.description,
    bgColor = props.bgColor,
    descriptionTextColor = props.descriptionTextColor,
    button = props.button,
    submitForm = props.submitForm,
    closeEmailCapture = props.closeEmailCapture,
    isVisible = props.isVisible,
    isSubmitting = props.isSubmitting,
    isSuccess = props.isSuccess,
    updateFormFields = props.updateFormFields,
    fields = props.fields,
    formFieldValues = props.formFieldValues,
    errors = props.errors,
    darkCloseBtn = props.darkCloseBtn;
  var _fields$ = fields[0],
    inputKey = _fields$.key,
    label = _fields$.label; // Banner only uses first field

  var value = formFieldValues[inputKey] || '';
  var errorMsg = errors[inputKey];
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Transition, {
    visible: isVisible,
    animation: "slide down",
    unmountOnHide: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Sticky, {
    active: true
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    style: {
      backgroundColor: bgColor
    },
    verticalAlign: "middle",
    className: "emailcapture-banner"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: "2",
    tablet: "1",
    only: "computer tablet"
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: "12",
    tablet: "13",
    only: "computer tablet",
    className: "emailcapture-banner-col"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: descriptionTextColor
    }
  }, description), isSuccess && /*#__PURE__*/_react["default"].createElement(_NoFormInputs["default"], null), !isSuccess && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, errorMsg && /*#__PURE__*/_react["default"].createElement("p", {
    className: "emailcapture-form-input-error",
    style: {
      color: descriptionTextColor
    }
  }, errorMsg), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
    error: errorMsg,
    placeholder: label,
    onChange: function onChange(event) {
      return updateFormFields(inputKey, event);
    },
    value: value
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    loading: isSubmitting,
    onClick: submitForm,
    style: {
      backgroundColor: button.bgColor,
      color: button.textColor
    }
  }, button.label))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: "2",
    tablet: "2",
    only: "computer tablet",
    className: "emailcapture-banner-close"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    as: "a",
    src: darkCloseBtn ? _closebtnDark["default"] : _closebtn["default"],
    onClick: closeEmailCapture
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    mobile: "13",
    only: "mobile",
    className: "emailcapture-banner-col"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: descriptionTextColor,
      textAlign: 'center'
    }
  }, description)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    mobile: "3",
    only: "mobile",
    className: "emailcapture-banner-close"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    as: "a",
    src: darkCloseBtn ? _closebtnDark["default"] : _closebtn["default"],
    onClick: closeEmailCapture
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    mobile: "16",
    only: "mobile",
    className: "emailcapture-banner-col"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
    placeholder: label,
    onChange: function onChange(event) {
      return updateFormFields(inputKey, event);
    },
    value: value
  }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    loading: isSubmitting,
    onClick: submitForm,
    style: {
      backgroundColor: button.bgColor,
      color: button.textColor
    }
  }, button.label)))));
};
var _default = Banner;
exports["default"] = _default;